import React from 'react';
import { Button } from '../ui/Button';
import { useDrawers } from '../../contexts/DrawerContext';
import { Phone, FileText } from 'lucide-react';
interface PageHeroProps {
  eyebrow: string;
  title: string;
  intro: string;
  imageSrc: string;
  imageAlt: string;
  primaryLabel?: string;
  primaryAction?: 'upload' | 'quote';
}
export function PageHero({
  eyebrow,
  title,
  intro,
  imageSrc,
  imageAlt,
  primaryLabel = 'Upload a contract',
  primaryAction = 'upload'
}: PageHeroProps) {
  const {
    openUpload,
    openQuote
  } = useDrawers();
  const primary = primaryAction === 'upload' ? openUpload : openQuote;
  const secondary = primaryAction === 'upload' ? openQuote : openUpload;
  return <section className="px-5 md:px-6 pt-12 md:pt-20 pb-12 md:pb-16 bg-background" data-id="element-550">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-551">
        <div className="lg:col-span-6" data-id="element-552">
          <p className="font-script text-2xl text-accent mb-1" data-id="element-553">{eyebrow}</p>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.08]" data-id="element-554">
            {title}
          </h1>
          <p className="mt-5 text-lg text-muted-ink leading-relaxed max-w-xl" data-id="element-555">
            {intro}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-556">
            <Button onClick={primary} variant="accent" size="lg" data-id="element-557">
              <FileText className="w-5 h-5" data-id="element-558" />
              {primaryLabel}
            </Button>
            <Button onClick={secondary} variant="outline" size="lg" data-id="element-559">
              {primaryAction === 'upload' ? 'Get a free quote' : 'Upload a contract'}
            </Button>
          </div>
          <a href="tel:+61386172600" className="mt-5 inline-flex items-center gap-2 text-ink font-semibold hover:text-accent transition-colors" data-id="element-560">
            <Phone className="w-4 h-4 text-accent" data-id="element-561" />
            Call (03) 8617 2600
          </a>
        </div>
        <div className="lg:col-span-6" data-id="element-562">
          <div className="relative rounded-4xl overflow-hidden shadow-warm" data-id="element-563">
            <img src={imageSrc} alt={imageAlt} className="w-full h-[320px] md:h-[440px] object-cover" data-id="element-564" />
          </div>
        </div>
      </div>
    </section>;
}